import React from 'react';
import {
  Flex,
  useColorMode,
  Icon,
  BoxProps,
  color,
  StyleProps,
} from 'deepstash-ui';
import NextImage, { NextImageProps } from 'src/components/image/NextImage';

const BOOK_IMAGE_STYLE: BoxProps = {
  w: '50%',
  h: '75%',
  zIndex: 2,
  borderTopRightRadius: '5%',
  borderBottomRightRadius: '5%',
};

interface BookImageCollectionProps {
  size: number;
  nextImageProps: NextImageProps;
}

const BookImageCollection: React.FC<BookImageCollectionProps & StyleProps> = ({
  size,
  nextImageProps,
  ...props
}) => {
  const { colorMode } = useColorMode();

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      pos="relative"
      flexShrink={0}
      zIndex={1}
      overflow="hidden"
      w={size}
      h={size}
      {...props}
    >
      <>
        <Icon
          width="100%"
          height="100%"
          viewBox="0 0 335 335"
          fill="none"
          position="absolute"
          {...props}
        >
          <g clipPath="url(#clip0_1658_106549)">
            <path
              d="M76 46C76 43.7909 77.7909 42 80 42H84V293.25H80C77.7909 293.25 76 291.459 76 289.25V46Z"
              fill={color[colorMode].text}
              fillOpacity="0.8"
            />
            <path
              d="M257 54C257 51.7909 255.209 50 253 50V285C255.209 285 257 283.209 257 281V54Z"
              fill="#FAF7F3"
            />
          </g>
        </Icon>
        <NextImage
          wrapperStyle={BOOK_IMAGE_STYLE}
          isNotInteractable={true}
          objectFit="cover"
          priority={true}
          {...nextImageProps}
        />
      </>
    </Flex>
  );
};

export default BookImageCollection;
